import React from "react";

import PageContent from "components/PageContent";
import ContactForm from "components/ContactForm";
import { usePageTitlePrefix } from "hooks/usePageTitlePrefix";
import welcomeImage from "resources/welcome.jpg";
import terminology from "terminology.json";

const PageBecomingAMentor: React.FunctionComponent = () => {
	usePageTitlePrefix(`Becoming a ${terminology.mentor}`);

	return (
		<PageContent>
			<header className="major">
				<h1>Request a demo</h1>
			</header>
			<span className="image main">
				<img src={welcomeImage} alt="Welcome" />
			</span>

			<p>
				If you are a language teacher, and are interested in using Aldeia,
				please get in touch to request a demo! Just fill out the form below. It
				will be great to meet you.
			</p>

			<ContactForm
				messagePlaceholder="Comments, questions, or anything else"
				enquiryType={`Enquiry about becoming a ${terminology.mentor} / request for a demo`}
			/>
		</PageContent>
	);
};

export default PageBecomingAMentor;
